import styled from "styled-components";
import { WHITE } from "@/constants/colors";
import { FONT_SIZE_BASE, TITLE, REGULAR } from "@/constants/fonts";
import { constants } from "@thecb/components";

export const FooterContainer = styled.div`
  background-color: ${constants.colors.LUCKY_POINT};
  display: flex;
  justify-content: center;
  padding: 0 45px;
  width: 100%;

  > div {
    justify-content: space-between;
  }
`;

export const FooterContent = styled.div`
  align-items: center;
  display: flex;
  max-width: 1258px;
  padding: 24px 0;
  width: 100%;
`;

export const FooterText = styled.div`
  font-family: ${TITLE};
  font-weight: ${REGULAR};
  font-size: ${FONT_SIZE_BASE};
  color: ${WHITE};
`;
